import React from 'react'

const HashTable = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/hashtable" width="100%" height="920px" title="HashTable"></iframe>
    </div>
  )
}

export default HashTable